<script setup></script>

<template>
  <div>
    <ul>
      <slot />
    </ul>
  </div>
</template>

<style lang="scss" scoped>
ul {
  padding: 0;
  margin: 0;
}
</style>
